import { connectRedux } from '@om1/platform-utils'
import { BackOfficeState } from '../state'
import { dataDeliveryActions } from '../state/data-delivery'
import { DataDeliveryCohortInputComponent } from './DataDeliveryCohortInputComponent'

export function createDataDeliveryCohortInputComponent<TState extends { backOffice: BackOfficeState }>() {
    return connectRedux(
        DataDeliveryCohortInputComponent,
        (state: TState) => ({
            registryTypes: state.backOffice.dataDelivery.registryTypes.registryTypes,
            registryTypesLoading: state.backOffice.dataDelivery.registryTypes.isLoading,
            cohorts: state.backOffice.dataDelivery.edit.cohorts,
            cohortsLoading: state.backOffice.dataDelivery.edit.ui.cohortsLoading
        }),
        dataDeliveryActions
    )
}

export type DataDeliveryCohortInput = ReturnType<typeof createDataDeliveryCohortInputComponent>
